"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_strings_1 = require("owa-strings");
var owa_mail_strings_1 = require("owa-strings/owa-mail-strings");
function getBlockSendersConfirmTitleAndSubtext(emailAddresses) {
    return [title(emailAddresses), subtext(emailAddresses)];
}
exports.default = getBlockSendersConfirmTitleAndSubtext;
function title(emailAddresses) {
    return formatSenders(emailAddresses, function (e) { return e.Name; }, owa_mail_strings_1.default.blockSendersTitle, owa_mail_strings_1.default.blockTwoSendersTitle, owa_mail_strings_1.default.blockThreeSendersTitle, owa_mail_strings_1.default.blockFourToSixSendersTitle, owa_mail_strings_1.default.blockSevenOrMoreSendersTitle);
}
function subtext(emailAddresses) {
    return formatSenders(emailAddresses, function (e) { return e.EmailAddress; }, owa_mail_strings_1.default.blockSendersSubtext, owa_mail_strings_1.default.blockTwoSendersSubtext, owa_mail_strings_1.default.blockThreeSendersSubtext, owa_mail_strings_1.default.blockFourToSixSendersSubtext, owa_mail_strings_1.default.blockSevenOrMoreSendersSubtext);
}
function formatSenders(emailAddresses, toText, oneSender, twoSenders, threeSenders, fourToSixSenders, sevenOrMoreSenders) {
    switch (emailAddresses.length) {
        case 0:
            throw new Error('formatSenders: no email addresses');
        case 1:
            return owa_strings_1.format(oneSender, toText(emailAddresses[0]));
        case 2:
            return owa_strings_1.format(twoSenders, toText(emailAddresses[0]), toText(emailAddresses[1]));
        case 3:
            return owa_strings_1.format(threeSenders, toText(emailAddresses[0]), toText(emailAddresses[1]));
        case 4:
        case 5:
        case 6:
            return owa_strings_1.format(fourToSixSenders, toText(emailAddresses[0]), toText(emailAddresses[1]), emailAddresses.length - 2);
        default:
            return owa_strings_1.format(sevenOrMoreSenders, toText(emailAddresses[0]), toText(emailAddresses[1]), emailAddresses.length - 2);
    }
}
//# sourceMappingURL=getBlockSendersConfirmTitleAndSubtext.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/actions/helpers/getBlockSendersConfirmTitleAndSubtext.js
// module id = 5663
// module chunks = 62